import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  model,
  untracked,
} from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { SelectFieldComponent } from '@custom-components/general/form/select-field/select-field.component';
import { TranslateModule } from '@ngx-translate/core';
import { InstallationDataSourcesStore } from '@root/app/store/installation-data-sources.store';
import { FedDevice, withDeviceDetails } from '../../fed-devices';

export interface DeviceOption {
  deviceId: number;
  label: string;
}

// A device's type name comes from the data sources, which are read only where there is a choice to
// make. Until they answer, or for a device they do not list, the LDN alone names it.
@Component({
  selector: 'xemex-installation-device-select',
  imports: [MatSelectModule, SelectFieldComponent, TranslateModule],
  providers: [InstallationDataSourcesStore],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './installation-device-select.component.html',
})
export class InstallationDeviceSelectComponent {
  readonly installationOid = input.required<string>();
  readonly devices = input.required<FedDevice[]>();
  readonly selected = model.required<number>();
  // A translation key.
  readonly label = input('installations.deviceSelect.label');

  private readonly dataSources = inject(InstallationDataSourcesStore);

  readonly options = computed<DeviceOption[]>(() =>
    withDeviceDetails(this.devices(), this.dataSources.dataSources()?.devices ?? []).map(
      device => ({
        deviceId: device.deviceId,
        label: device.typeName ? `${device.typeName} · ${device.ldn}` : device.ldn,
      }),
    ),
  );

  constructor() {
    effect(() => {
      const installationOid = this.installationOid();
      untracked(() => this.dataSources.load(installationOid));
    });
  }
}
